import styled from '@emotion/styled';
import { theme } from '@landsbankinn/ui';
import React, { useState } from 'react';
import { animated, useSpring } from 'react-spring';

interface IProps {
  desc?: boolean;
}

const Arrow = styled(animated.div)`
  background: ${theme.colors.primary};
  height: 1px;
  width: 10px;

  position: relative;
  transform: rotate(90deg);
  cursor: pointer;

  &:before,
  &:after {
    content: '';
    background: ${theme.colors.primary};
    position: absolute;
    height: 1px;
    width: 4px;
  }

  &:before {
    right: -0.5px;
    bottom: -1px;
    transform: rotate(-45deg);
  }

  &:after {
    right: -0.5px;
    bottom: 1px;
    transform: rotate(45deg);
  }
`;

export function OrderByArrow({ desc }: IProps) {
  const [deg, setDeg] = useState(0);

  React.useEffect(() => {
    // Up / Asc -> 270
    // Down / Desc -> 90
    const isArrowDirectionDesc =
      deg === 90 || deg - 360 * Math.floor(deg / 360) === 90 ? true : false;

    if (deg === 0) {
      desc ? setDeg(90) : setDeg(270);
    } else {
      if ((desc && !isArrowDirectionDesc) || (!desc && isArrowDirectionDesc)) {
        setDeg(deg + 180);
      }
    }
  }, [deg, desc]);

  const rotate = useSpring({
    config: {
      mass: 20,
      tension: 469,
      friction: 20,
      clamp: true,
    },

    opacity: 1,
    transform: `rotate(${deg}deg)`,
  });
  return <Arrow style={rotate} />;
}
